jQuery(document).ready(function onProductNavigationReady($) {
    "use strict";

    var $category_nav = $('.nav-categories');
    $('.nav-desktop--primary ul li:first-child a, .js-toggle-products-menu').on('click', onNavClick);

    function onNavClick(e) {
        e.preventDefault();
        $category_nav.toggleClass('nav-categories--open');
    }
});